import {combineReducers} from 'redux';

import {CONTRACTOR_REQUEST, CONTRACTOR_SUCCESS, CONTRACTOR_FAILURE} from '../actions';
import {UPDATE_CONTRACTOR_REQUEST, UPDATE_CONTRACTOR_SUCCESS, UPDATE_CONTRACTOR_FAILURE} from '../actions';

import admins from './contractor-admins';
import preferences from './contractor-preferences';
import insurances from './contractor-insurances';
import engineers from './contractor-engineers';
import business from './contractor-business';
import qualifications from './contractor-qualifications';
import nonEngineers from './contractor-non-engineers';

export const CONTRACTOR_INITIAL_STATE = {
    id: null,
    isFetching: false,
    error: null,
    business_name: '',
    address_line_1: '',
    address_line_2: '',
    address_line_3: '',
    post_code: '',
    contact_name: '',
    phone_number: '',
    contact_email: '',
    gas_safe_number: ''
};

const contractorReducers = {
    [CONTRACTOR_REQUEST]: (state, {id}) => {
        return {...state, id, isFetching: true, error: null};
    },
    [CONTRACTOR_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null};
    },
    [CONTRACTOR_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [UPDATE_CONTRACTOR_REQUEST]: (state, action) => {
        return {...state, isFetching: true, error: null};
    },
    [UPDATE_CONTRACTOR_SUCCESS]: (state, {res}) => {
        return {...state, ...res.data, isFetching: false, error: null}
    },
    [UPDATE_CONTRACTOR_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error}
    }
};

const contractorReducer = (state = CONTRACTOR_INITIAL_STATE, action) => {
    let reducer = contractorReducers[action.type] || (state => state);
    return reducer(state, action);
};

export default combineReducers({
    profile: contractorReducer,
    admins,
    preferences,
    insurances,
    engineers,
    business,
    qualifications,
    nonEngineers
});


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/contractor.js